// extracted by mini-css-extract-plugin
module.exports = {"tag":"shop-module--tag--2x7eo","slide":"shop-module--slide--3Xa0b"};